/** @module Enums */ /** typedoc */

export enum CollaborationEntityEnum {
    Audio = 'Asset',
    Stem = 'Asset',
    Video = 'Asset',
    Album = 'Asset',
    Asset = 'Asset',
    Project = 'Project',
    project = 'Project'
}
